import { AlertType } from '../../../../shared/ui/alert/alert';

export interface AlertData {
  message: string;
  type: AlertType;
  visible: boolean;
}

export class Alert {
  constructor(
    public readonly message: string,
    public readonly type: AlertType = 'info',
    public readonly visible: boolean = false
  ) {}

  public static warning(message: string, visible: boolean = false) {
    return new Alert(message, 'warning', visible);
  }

  public static error(message: string, visible: boolean = false) {
    return new Alert(message, 'danger', visible);
  }

  public data(): AlertData {
    return {
      message: this.message,
      type: this.type,
      visible: this.visible,
    };
  }
  public setVisibility(visible: boolean) {
    return new Alert(this.message, this.type, visible);
  }
}
